import {injectIntl} from 'react-intl';
import React, {Component} from 'react';
import Form from "../../../../ui/Form";
import Input from "../../../../ui/Input";
import Button from "../../../../ui/Button";
import {Field, reduxForm, getFormSubmitErrors} from "redux-form/immutable";
import connect from "react-redux/es/connect/connect";
import FormHint from "../../../../ui/FormHint";
import {FormattedMessage} from "react-intl";

const renderInputField = props => {
    return (
        <Form.Control erroneous={!!props.error}>
            <Form.Label htmlFor={props.input.name} required><FormattedMessage id={props.label} /></Form.Label>
            <Input {...props.input} disabled={props.disabled} type={props.type} />
            {props.error && (<FormHint>{props.error}</FormHint>)}
        </Form.Control>
    );
};

@injectIntl
export class ChangePasswordForm extends Component {

    render() {
        const { handleSubmit, submitting, submitErrors } = this.props;

        return (
            <Form onSubmit={handleSubmit}>
                <Field name='current_password'
                    error={submitErrors && submitErrors.get('currentPassword')}
                    component={renderInputField}
                    label='frontend.profile.change_password.current_password'
                    type='password'
                    disabled={submitting} />

                <br/>

                <Field name='password'
                    error={submitErrors && submitErrors.get('password')}
                    component={renderInputField}
                    label='frontend.profile.change_password.new_password'
                    type='password'
                    disabled={submitting} />

                <br/>

                <Field name='password_confirmation'
                    error={submitErrors && submitErrors.get('passwordConfirmation')}
                    component={renderInputField}
                    label='frontend.profile.change_password.new_password_confirm'
                    type='password'
                    disabled={submitting} />

                <br/>

                <Button emphasis='default' type='submit'>
                    <FormattedMessage id='frontend.profile.change_password.button'/>
                </Button>
            </Form>
        );
    }
}

let FormComponent = reduxForm({
    form: 'change_password',
})(ChangePasswordForm);

FormComponent = connect(state => ({
    submitErrors: getFormSubmitErrors('change_password')(state)
}))(FormComponent);

export default FormComponent